<template>
    <div> 
        <div  class="map_filter">
            <div class="maphighlight__box torrespaseop">
                <h1 class="caption__select">
                    <span>{{img.name==='NIVEL 0' ? 'PLANTA BAJA': img.name}}</span>
                </h1>
                <map-highlight @activeDetailPiso="activeData" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../../core/rediseno/MapHighlightPiso.vue";


export default {
    name: "Piso",
    components: {
        MapHighlight,
    },
    data() {
        return {
            id: 35,
            levelId: this.$route.params.idPiso,
            type: "departamentos",
            desarrollo: "canadas_deptos-piso",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
            privadas: {
                NIVEL0: {
                    name: 'NIVEL 0',
                    url: (this.$route.params.id == 91 || this.$route.params.id == 94 || this.$route.params.id == 96  || this.$route.params.id == 97 || this.$route.params.id == 98 || this.$route.params.id == 99) ? 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelSINacceso.jpg': 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelAcceso.webp',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL1: {
                    name: 'NIVEL 1',
                    url: (this.$route.params.id == 91 || this.$route.params.id == 94) ? 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelSINacceso.jpg': 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelAcceso.webp',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL2: {
                    name: 'NIVEL 2',
                    url: (this.$route.params.id != 91 && this.$route.params.id != 94) ? 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelSINacceso.jpg': 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelAcceso.webp',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles/`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL3: {
                    name: 'NIVEL 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelSINacceso.jpg',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL4: {
                    name: 'NIVEL 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepasNivelSINacceso.jpg',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
        };
    },
    computed: {
        ...mapGetters({
            locations: "getStatusA",
            level:"getStatusLevel",
            /* selected: 'getStatusA', */
            filterModelos: "getStatusFilterModelos", 
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            let pisoSpace = this.level.name ? this.level.name : ''
            if(pisoSpace){
                const piso = pisoSpace.replace(" ", '');
                const pisoSeleccionado = this.privadas[piso];
                return pisoSeleccionado;
            }else{
                return false
            } 
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        activeData(){
            this.$emit('activeDetailPiso');
        }
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        /* await this.clearCoords(); */
    },
    mounted() {

    }
};
</script>
